import { useContext} from 'react';
import { LanguageContext } from '../../index';


const About2 = (props) => {
    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    return (
        <section className="about-section">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="about-image mr-50 rmr-0">
                            <div className="experience-year">
                                <span className="number">16</span>
                                <h4>
                                    {isPolish ? (
                                        <>Lat <br /> doświadczenia</>
                                    ) : (
                                        <>Years <br /> of experience</>
                                    )}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="wp-content about-content mb-10 ml-50 pt-100 rmb-50">
                            <div className="section-title mb-10">
                                <h6>Fabri</h6>
                                <h2>
                                    {isPolish ? (
                                        <>
                                            Efektywny <br />
                                            <span>zespół tworzący podłogi</span> <br />
                                            <span className="thin">drewniane</span>
                                        </>
                                    ) : (
                                        <>
                                            Efficient <br />
                                            <span>team creating wooden</span> <br />
                                            <span className="thin">floors</span>
                                        </>
                                    )}
                                </h2>
                                <h6 className='about_p'>
                                    {isPolish ? 'klasy premium' : 'premium class'}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About2;